import { worstSeverity } from "./severity";
/**
 * The output of a validator whose result holds a list of findings: valid when the
 * list is empty, with the worst severity of the list otherwise.
 */
export function createValidationOutput(validator, findings, result) {
    var _a, _b;
    const isValid = findings.length === 0;
    return {
        name: validator.name,
        isValid,
        messageTranslationKey: isValid ? validator.okTranslationKey : validator.errorTranslationKey,
        specialScopes: validator.specialScopes,
        severity: worstSeverity(findings, (_a = validator.severity) !== null && _a !== void 0 ? _a : "error"),
        stage: (_b = validator.stage) !== null && _b !== void 0 ? _b : "semantic",
        result,
    };
}
